import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var messageReceived = createAction("".concat(actionKey, "/RECEIVED"), function (message) { return message; });
//# sourceMappingURL=action.js.map